export default __webpack_public_path__ + "locales/cs/DataReassignmentDialog.json?hash=ad0c9c1bcc2d4ea77bacf04033c90d68";